import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AAD_LOGOUT_SUCCESS } from "actions/types";
import { AuthBranding as Branding } from "components/common/branding";

export const Logout = () => {
  const { keycloak } = useKeycloak();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const performLogout = async () => {
      if (keycloak.authenticated) {
        dispatch({ type: AAD_LOGOUT_SUCCESS });
        keycloak.logout({
          redirectUri:
            process.env.REACT_APP_REDIRECT_URI || window.location.origin,
        });
      } else {
        dispatch({ type: AAD_LOGOUT_SUCCESS });
        navigate("/login");
      }
    };

    performLogout();
  }, [keycloak, dispatch, navigate]);

  return <Branding />;
};
